import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useLazyQuery } from '@grandvisionhq/graphql';
import { useIntl } from '@grandvisionhq/state';
import { GET_APPOINTMENT_BY_TOKEN } from '../../queries/get-appointment-by-token.js';
import '../../queries/get-appointment-by-id.js';
import '../../queries/get-store-by-code.js';
import '../../queries/get-store-by-id.js';
import '../../queries/reschedule-appointment-by-id.js';
import '../../queries/reschedule-appointment-by-token.js';
import { fromAppointmentQueryToAppointment } from './adapters/fromAppointmentQueryToAppointment.js';

const useAppointmentByToken = (variables)=>{
    const { locale  } = useIntl();
    const [query, queryState] = useLazyQuery(GET_APPOINTMENT_BY_TOKEN, {
        variables,
        context: {
            fetchPolicy: 'no-cache',
            forwardHeaders: {
                'Accept-Language': locale
            }
        }
    });
    const data = React.useMemo(()=>{
        var ref;
        return ((ref = queryState.data) === null || ref === void 0 ? void 0 : ref.appointmentByToken) ? fromAppointmentQueryToAppointment(queryState.data.appointmentByToken) : null;
    }, [
        queryState
    ]);
    return React.useMemo(()=>[
            query,
            swcHelpers.objectSpread({}, queryState, {
                data
            }), 
        ]
    , [
        data,
        queryState,
        query
    ]);
};

export { useAppointmentByToken as default };
//# sourceMappingURL=use-appointment-by-token.js.map
